module.exports = __webpack_public_path__ + "img/wallPaper1.70e4c5e2.png";